import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        // fontFamily: `'Poppins', 'Roboto', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif`,
        fontFamily: `'Chivo', Arial, sans-serif`,
        // fontFamily: '"Myriad Pro", Arial, sans-serif',
    },
});

export default theme; 